import { render, staticRenderFns } from "./ticketing-text.vue?vue&type=template&id=ead3fa48&"
import script from "./ticketing-text.vue?vue&type=script&lang=js&"
export * from "./ticketing-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ticketing-text.vue?vue&type=custom&index=0&blockType=route&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports